import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Notification, { notifyApiError } from "components/Notification";
import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import {
  getAllRoles,
  deleteRole,
  resetPayload,
  DELETE_ROLE
} from "store/actions/roleAction";
import { SpinnerRainbow } from "components/Spinner";
import NoData from "../NoData";
import Translate from "helpers/Translate";

export class Role extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllRoles({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(Translate({ id: "data_deleted_successfully" }));
      this.props.resetPayload(DELETE_ROLE);
      this.props.getAllRoles({ page: 1 });
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.name] }),
      {
        onOk: () => {
          this.props.deleteRole(id);
        }
      }
    );
  };

  onPageChange = data => {
    let selectedPage = parseInt(data.selected) + 1;
    this.props.getAllRoles({ page: selectedPage });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.roles &&
      this.props.roles.data &&
      this.props.roles.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage">
            <i className="fas fa-long-arrow-alt-left"></i>{" "}
            {Translate({ id: "back_to_manage_dashboard" })}
          </Link>
          <div className="manage-page-heading">
            <span className="manage-page-icon tone-violet" aria-hidden="true">
              <i className="fas fa-user-lock"></i>
            </span>
            <div className="manage-page-heading__text">
              <h1 className="title">{Translate({ id: "manage_roles" })}</h1>
              <p className="manage-page-subtitle">
                {Translate({ id: "manage_roles_description" })}
              </p>
            </div>
          </div>
          <div className="manage-list-actions manage-list-actions--end">
            <Link
              data-test="btnadd"
              to="/manage/roles/add"
              className="btn btn-primary btn-add-manage"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_role" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.roles && this.props.roles.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "title" })} </th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {this.hasData() &&
                    this.props.roles.data.map(item => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              title="Edit"
                              to={`/manage/roles/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              title="Delete"
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

Role.propTypes = {
  getAllRoles: PropTypes.func.isRequired,
  roles: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    roles: state.role.getAllRoles,
    isLoading: state.role.isLoadingRole,
    deleteStatus: state.role.deleteRoleStatus,
    error: state.role.errorRole
  };
};

export default connect(mapStateToProps, {
  getAllRoles,
  deleteRole,
  resetPayload
})(Role);
